<div class="action-flyout-container">
  <div class="action-header">
    <img
      class="app-logo"
      src="{{
        (flyoutOpeningData.action[0]?.nameAction || flyoutOpeningData.action.nameAction) === 'Custom' && customIntegrationData?.iconUrl
          ? customIntegrationData.iconUrl
          : (flyoutOpeningData.action[0] || flyoutOpeningData.action | getAutomationIcons)
      }}"
      [ngClass]="{ reverseColor: (flyoutOpeningData.action[0] || flyoutOpeningData.action | getColorAutomationIcons) }"
      alt="app-image" />
    <div class="automation-app-name">
      {{
        (flyoutOpeningData.action[0]?.nameAction || flyoutOpeningData.action.nameAction) === "Custom" && customIntegrationData?.name
          ? customIntegrationData.name
          : flyoutOpeningData.action[0]?.nameAction || flyoutOpeningData.action.nameAction
      }}
    </div>
  </div>
  <app-action-automation [flyoutOpeningData]="flyoutOpeningData"></app-action-automation>
</div>
